import { gql } from '@apollo/client';

export const GET_EVENT_DEATILS_INFO = gql`
  query MyQuery($slug: String!) {
    getEventDetailBySlug(slug: $slug) {
      id
      aampp
      active
      adultOnly
      bannerUrl
      categories {
        id
        name
      }
      created
      community {
        id
        name
      }
      customVariables {
        approved_applicant_location
        chat_pack_list
        chatpackdelivery_date
        copybrand_name
        eventname_article
        product_name
        socialshare_hashtags
      }
      deleted
      description
      disclaimer
      discoverable
      discussionCount
      displayLimit
      displayName
      eventData {
        additionalAttributes {
          stores
        }
        hashtag
        partyPackName
      }
      eventPattern
      eventOptinConfiguration {
        experienceStrategy
        experienceSelectionLimit
      }
      eventType
      featured
      featuredEnd
      featuredStart
      forceAddressVerification
      heroPlayList {
        autoPlay
        expires
        id
        mediaUrl
        mobileHero
        published
        assets {
          assetId
          basename
          mimeType
          hlsPlaylistUrl
          description
          webmUrl
          url
          type
          thumbnailUrl
          mp4Url
        }
      }
      forceChildrenVerification
      languageId
      likeCount
      liked
      listed
      milestones {
        applicationEndDate
        applicationStartDate
        buildupEndDate
        buildupStartDate
        completeStartDate
        completeEndDate
        experienceEndDate
        experienceStartDate
        noticeEndDate
        noticeStartDate
        openEndDate
        openStartDate
        partyEndDate
        partyRangeEndDate
        partyRangeStartDate
        partyStartDate
        postTrialEndDate
        postTrialStartDate
        preTrialEndDate
        preTrialStartDate
        reportingEndDate
        reportingStartDate
        selectionEndDate
        trialEndDate
        selectionStartDate
        trialStartDate
      }
      modified
      name
      ongoing
      packAndApplicationCount {
        noOfApplicant
        noOfPack
        refundPackData {
          availablePacks
          nextPacksDropDate
          refundAllocationExpiryDate
        }
      }
      sendSelectionNotification
      slug
      sponsorDescription
      sponsorId
      sponsorName
      summary
      template
      virtual
      website
    }
  }
`;

export const GET_PRODUCT_INFO = gql`
  query MyQuery($eventId: Int!) {
    getProduct(eventId: $eventId) {
      id
      description
      name
      heroPlayList {
        autoPlay
        id
        mediaUrl
        asset {
          assetType
          basename
          checksum
          conversionStatusBits
          description
          hlsPlaylistUrl
          id
          isExternal
          mimeType
          mp4Url
          provider
          providerId
          sharedURL
          thumbNailUrl
          webmUrl
        }
      }
      ratingCount
      reviewURL
      reviewable
      slug
    }
  }
`;

export const GET_ACTIVITY_GROUP = gql`
  query MyQuery($eventId: Int!) {
    getActivityGroup(eventId: $eventId) {
      id
      name
      activities {
        id
        tasks {
          name
          id
        }
      }
    }
  }
`;
